import { store } from '/@/store'

export const useSidebarStore = defineStore('sidebar', () => {
  const { biggerThan, smallerThan } = useScreenSize()

  /**
   * @name isVisible
   * @description Holds sidebar's visible state
   */
  const isVisible = ref()

  /**
   * @name isBiggerThanLg
   * @description If screen is bigger than lg value, returns true
   */
  const isBiggerThanLg = computed(() => biggerThan('lg'))

  /**
   * @method toggle
   * @description When execute this function, hides or not sidebar.
   */
  function toggle() {
    if (smallerThan('lg')) isVisible.value = !isVisible.value
  }

  watch(
    isBiggerThanLg,
    (value) => {
      isVisible.value = value
    },
    { immediate: true },
  )

  return { isVisible, toggle }
})

// Need to be used outside the setup
export function useSidebarStoreWithout() {
  return useSidebarStore(store)
}

/**
 * Pinia supports Hot Module replacement, so you can edit your store and
 * interact with them directly in your app without reloading the page.
 *
 * @see https://pinia.esm.dev/cookbook/hot-module-replacement.html
 * @see https://vitejs.dev/guide/api-hmr.html
 */
if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useSidebarStore, import.meta.hot))
}
